<template>
  <div>
    <div class="container-fluid">
      <div
        class="form py-4 col-md-7 col-sm-9 col-lg-4 col-xs-12 col-11 mx-auto"
      >
        <h4 class="text-center my-3 form-heading">
          Welcome to Bookinga Admin Registration board
        </h4>
        <form>
          <p
            class="errors mb-3 col-lg-10 col-md-10 col-11 col-sm-10 mx-auto"
            id="error"
            v-show="NewError"
          ></p>

          <p
            class="success mb-3 col-lg-10 col-md-10 col-11 col-sm-10 mx-auto"
            id="success"
            v-show="success"
          ></p>

          <div class="form-group col-lg-10 col-md-10 col-11 col-sm-10 mx-auto">
            <input
              type="text"
              class="form-control"
              placeholder="Enter First name "
              name="firstname"
              id="firstname"
              v-model="data.Firstname"
              required
            />

            <!-- <label class="form-label" for="firstname">First name</label> -->
          </div>

          <div class="form-group col-lg-10 col-md-10 col-11 col-sm-10 mx-auto">
            <input
              type="text"
              class="form-control"
              placeholder="Enter Last name "
              name="lastname"
              id="lastname"
              v-model="data.Lastname"
              required
            />

            <!-- <label class="form-label" for="lastname">Last name</label> -->
          </div>
          <div class="form-group col-lg-10 col-md-10 col-11 col-sm-10 mx-auto">
            <input
              type="email"
              class="form-control"
              placeholder="Enter Email "
              name="email"
              id="email"
              v-model="data.Email"
              required
            />

            <!-- <label class="form-label" for="email">Email</label> -->
          </div>
          <div class="form-group col-lg-10 mx-auto col-md-10 col-11 col-sm-10">
            <label class="form-labe" for="phoneCodes">Phone number</label>

            <br />

            <span class="f-small"
              >*First select the country phone code then fill the remaining
              numbers in the phone number box*</span
            >

            <select
              class="form-control"
              v-model="data.selector"
              @change="getCode()"
              name="phoneCodes"
              id="phoneCodes"
              required
            >
              <option
                v-for="phoneCode in phoneCodes"
                v-bind:value="phoneCode.code"
                :key="phoneCode.code"
              >
                {{ phoneCode.code }} --
                {{ phoneCode.name }}
              </option>
            </select>
          </div>

          <div
            class="input-group mt-3 mb-3 col-lg-10 col-md-10 col-11 col-sm-10 mx-auto"
          >
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">{{
                currentCode
              }}</span>
            </div>

            <input
              type="number"
              class="form-control"
              placeholder="Phone number"
              name="phone"
              id="phone"
              v-model="data.phone"
              aria-describedby="basic-addon1"
              required
            />
          </div>

          <div class="form-group col-lg-10 col-md-10 col-11 col-sm-10 mx-auto">
            <select
              class="form-control"
              v-model="data.Gender"
              name="gender"
              id="gender"
              required
            >
              <option disabled value>--Select gender--</option>

              <option value="M">Male</option>

              <option value="F">Female</option>
            </select>
          </div>

          <div class="text-center my-3">
            <button
              type="submit"
              @click.prevent="registerAdmin"
              class="btn btn_styles btn-md btn-primary"
            >
              Register now
              <span
                v-if="hasSubmitted"
                class="spinner-border spinner-border-sm ml-2 my-auto py-auto"
              ></span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import phoneCodes from "../user-management/phoneCodes.json";
import CryptoJS from "crypto-js";
import jwt_decode from "jwt-decode";
const url = "https://bookinga.herokuapp.com/api/v1/company/admin";
import router from "../../router/index";

let config = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("jwt"),
  },
};
export default {
  data() {
    return {
      currentCode: "+250",
      NewError: false,
      success: false,
      UserCountryName: "",
      phoneCodes: phoneCodes.countries,
      data: {
        Firstname: "",
        Email: "",
        selector: "+250",
        Lastname: "",
        phone: "",
        Gender: "",
      },
      hasSubmitted: false,
    };
  },

  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },

  created() {
        const token = localStorage.getItem("jwt");
        const decoded = jwt_decode(token);
        const userRole = decoded.role;
        if (userRole != "developer") {
          return router.push("/dashboard");
        }
  },
  methods: {
    getCode() {
      this.currentCode = this.data.selector;
    },
    registerAdmin: function() {
      if (
        this.data.Lastname.length < 1 ||
        this.data.Firstname.length < 1 ||
        this.data.phone.length < 1 ||
        this.data.Gender.lenght == "" ||
        this.data.Email.length == ""
      ) {
        this.NewError = true;
        document.getElementById("error").innerHTML =
          "All fields must be filled";
      } else if (
        this.data.Lastname.length < 2 ||
        this.data.Lastname.length > 41
      ) {
        this.NewError = true;
        document.getElementById("error").innerHTML =
          "Last name must be more than 2 characters and not greater than 40";
      } else if (
        this.data.Firstname.length < 2 ||
        this.data.Firstname.length > 41
      ) {
        this.NewError = true;
        document.getElementById("error").innerHTML =
          "First name must be more than 2 characters and not greater than 40";
      } else if (this.data.phone.length < 3 || this.data.phone.length > 14) {
        this.NewError = true;
        document.getElementById("error").innerHTML =
          "The provided phone number should be a valid phone number";
      } else if (this.data.Gender.length == "") {
        this.NewError = true;
        document.getElementById("error").innerHTML =
          "Please select your gender";
      } else {
        this.hasSubmitted = !this.hasSubmitted;
        axios
          .post(
            url,
            {
              lastName: this.data.Lastname,
              firstName: this.data.Firstname,
              phoneNumber: this.currentCode + this.data.phone,
              gender: this.data.Gender,
              email: this.data.Email,
            },
            config
          )
          .then((response) => {
            if (response.data.status == 201) {
              this.NewError = false;
              this.success = true;
              document.getElementById("success").innerHTML =
                "New Admin Registered successfully";
              this.hasSubmitted = false;
              return (
                (this.data.Email = ""),
                (this.data.Firstname = ""),
                (this.data.Lastname = ""),
                (this.data.phone = ""),
                (this.data.Gender = "")
              );
            } else if (response.data.status == 400) {
              this.NewError = true;
              this.hasSubmitted = !this.hasSubmitted;
              document.getElementById("error").innerHTML =
                response.data.message;
            } else {
              this.NewError = true;
              this.hasSubmitted = !this.hasSubmitted;
              document.getElementById("error").innerHTML =
                response.data.message;
            }
          })
          .catch((error) => {
            this.NewError = true;
            document.getElementById("error").innerHTML =
              "An error occured in registering Admin! Try again";
            this.hasSubmitted = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
